var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37237 6.78155L6.22413 6.80992M6.22413 6.80992L6.19862 2.52626M6.22413 6.80992L1 1M2.37237 11.2185L6.22413 11.1901M6.22413 11.1901L6.19862 15.4737M6.22413 11.1901L1 17M15.6276 6.78155L11.7759 6.80992M11.7759 6.80992L11.8014 2.52626M11.7759 6.80992L17 1M15.6276 11.2185L11.7759 11.1901M11.7759 11.1901L11.8014 15.4737M11.7759 11.1901L17 17",
    stroke: "#979797",
    strokeWidth: 1.12924
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zoomOut.80e3cfeb5fba172e1bf511424f969c3d.svg";